import React from 'react';
import { useDispatch } from 'react-redux';
import { ReviewMopAddressContainer, ReviewMopAddressText, ReviewMopContainer, ReviewMopHeading, ReviewMopLink } from './styled';
import { formatProperCase, getValidZip } from './helper';
import { ElementType, getCountryName, SubType, SpecType, sendRioEvent } from '@chegg/commerce-utils';
import { setModeClickHandler } from '../DefaultMopView/helpers';
import { useAppSelector } from '../../hooks/useAppSelector';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { getPaymentFieldLabelText } from '../UserAddress/utils/getPaymentFieldLabelText';
import { PaymentFormDataFields } from '../UserAddress/constants';
import { getString } from '../../constants/Strings';
import { MopDisplayContent } from '../MopDisplayContent';
import { ACCOUNT_TYPE } from '../../constants/PaymentTypes';
import { selectedMopSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
import { configSelector, paymenFormSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import { resetForm } from '../../redux/PaymentState/helpers/resetForm';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var ReviewMopView = function ReviewMopView(props) {
  var hostedFieldsService = props.hostedFieldsService;
  var selectedMop = useAppSelector(selectedMopSelector);
  var paymentForm = useAppSelector(paymenFormSelector);
  var config = useAppSelector(configSelector);
  var rioNamespace = config.rioNamespace;
  var _selectedMop$billingA = selectedMop.billingAddress,
    fname = _selectedMop$billingA.fname,
    lname = _selectedMop$billingA.lname,
    city = _selectedMop$billingA.city,
    state = _selectedMop$billingA.state,
    zip = _selectedMop$billingA.zip,
    country = _selectedMop$billingA.country;
  var countryCode = country !== null && country !== void 0 ? country : '';
  var dispatch = useDispatch();
  var editClickhandler = function editClickhandler(e) {
    e.preventDefault();
    if (selectedMop.accountType === ACCOUNT_TYPE.CREDIT_CARD) {
      setModeClickHandler(AppMode.EDIT, AppMode.DEFAULT_MOP, dispatch);
    } else {
      setModeClickHandler(AppMode.DEFAULT_MOP, AppMode.DEFAULT_MOP, dispatch);
      // Rio log on Edit click for Paypal/Applepay
      sendRioEvent({
        info: getString('APP.RIO.EVENTS.EL_NAME.EDIT_PAYMENT_INFO'),
        specType: SpecType.INTERACTION,
        subType: SubType.CLICK,
        elementType: ElementType.LINK,
        callback: sendRioEventCallback,
        namespace: rioNamespace
      });
      hostedFieldsService && resetForm(hostedFieldsService, dispatch);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReviewMopContainer, {
    "data-test": DataTestAttributes.SELECTED_MOP_VIEW
  }, /*#__PURE__*/React.createElement(ReviewMopHeading, null, getPaymentFieldLabelText(PaymentFormDataFields.PAYMENT_METHOD, paymentForm) || getString('APP.SELECTEDMOPVIEW.HEADER'), /*#__PURE__*/React.createElement(ReviewMopLink, {
    "data-test": DataTestAttributes.EDIT_MOP_LINK,
    hasButtonBehavior: true,
    href: '#',
    role: 'button',
    onClick: editClickhandler
  }, getPaymentFieldLabelText(PaymentFormDataFields.EDIT, paymentForm) || getString('APP.MOPONFILE.EDIT'))), /*#__PURE__*/React.createElement(MopDisplayContent, {
    mop: selectedMop,
    withoutCardholderName: selectedMop.accountType === ACCOUNT_TYPE.CREDIT_CARD
  }), /*#__PURE__*/React.createElement(ReviewMopAddressContainer, null, /*#__PURE__*/React.createElement(ReviewMopAddressText, {
    "data-test": DataTestAttributes.MOP_USER_NAME
  }, fname, " ", lname), /*#__PURE__*/React.createElement(ReviewMopAddressText, {
    "data-test": DataTestAttributes.MOP_USER_ADDRESS
  }, formatProperCase(city), " ", state, " ", getValidZip(zip)), /*#__PURE__*/React.createElement(ReviewMopAddressText, {
    "data-test": DataTestAttributes.MOP_USER_COUNTRY
  }, getCountryName(countryCode)))));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/ReviewMopView/index.js
// module id = 4574
// module chunks = 11